import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { AuthLayout } from '@/layouts/AuthLayout'
import { ChangePasswordForm } from '@/components/domain/ChangePasswordForm'
import { useToast } from '@/components/ui/Toast'

/**
 * Onboarding password change screen logic.
 */
export function ChangePasswordPage() {
  useDocumentTitle('Change password')

  const { user, mustChangePassword } = useAuth()
  const navigate = useNavigate()
  const { toast } = useToast()

  return (
    <AuthLayout>
      <div className="flex flex-col gap-4">
        <header className="flex flex-col gap-1">
          <h1 className="text-h1 font-semibold text-text">
            {mustChangePassword ? 'Choose your password' : 'Change password'}
          </h1>
          {mustChangePassword && (
            <p className="text-sm text-muted">
              Your account was set up by an administrator. Please choose a password only you know.
            </p>
          )}
          {user && <p className="text-xs text-subtle">{user.email}</p>}
        </header>

        <ChangePasswordForm
          currentPasswordLabel={mustChangePassword ? 'Password you were given' : 'Current password'}
          submitLabel={mustChangePassword ? 'Save and continue' : 'Change password'}
          onSuccess={() => {
            toast('Password changed. Your other sessions have been signed out.')
            void navigate('/', { replace: true })
          }}
        />
      </div>
    </AuthLayout>
  )
}
